<template>
  <div class="match-play">
    <nav class="navbar navbar-expand-lg navbar-light bg-light border-bottom shadow-sm mb-3">
      <div class="container">
        <router-link class="navbar-brand" to="/">
          <svg width="1.5em" height="1.5em" viewBox="0 0 16 16" class="back-icon bi bi-arrow-left-short" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>
          </svg>
          <span>{{$t('general.match')}}</span>
        </router-link>
        <h2 class="pt-2 mr-4" v-if="match">{{ match.matchPlayedTime }}</h2>
        <div class="btn-group" v-if="!match.isRunning">
          <button            
            class="btn btn-primary"
            v-on:click="startMatch()"
          >
            <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-play-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
            </svg> 
            Start
          </button>
          <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-expanded="false">
            <span class="sr-only">Toggle Dropdown</span>
          </button>
          <ul class="dropdown-menu dropdown-menu-right">            
            <li>
              <button class="dropdown-item" v-on:click="restartMatch()">
                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-arrow-repeat" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/>
                  <path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"/>
                </svg>
                {{$t('play.restart')}}
              </button>
            </li>
            <li>
              <button class="dropdown-item" v-on:click="deleteMatch()">
                <svg
                  width="1.2em"
                  height="1.2em"
                  viewBox="0 0 16 16"
                  class="bi bi-x"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                  />
                </svg>
                {{$t('details.delete')}}
              </button>
            </li>
          </ul>
        </div>
        <button v-else class="btn btn-warning" v-on:click="stopMatch()">
          <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-pause-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"/>
          </svg>
          Pause
        </button>
      </div>
    </nav>
    <transition name="fade">
      <div class="container space-below" v-if="matchLoaded">
        
        <div class="row mb-1">
          <div class="col-10 text-muted text-truncate">
            <h4 v-if="match && match.opponent && match.opponent != ''">
              {{ match.opponent }}          
            </h4>
            <h4 v-else>{{$t('play.noDescriptionSpecified')}}</H4>          
          </div>
          <div class="col-2 text-right">
            <a v-on:click="editMatch(match)" class="ml-3 text-muted">
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                class="bi bi-pencil"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5L13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175l-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"
                />
              </svg>
            </a>
          </div>
        </div>
        <div v-if="!match.players || match.players.length == 0">
          <div class="alert alert-warning">{{$t('play.noPlayersAdded')}}</div>
          <a class="btn btn-primary" v-on:click="editMatch(match)">{{$t('play.configureTheTeam')}}</a>
        </div>
        <transition name="fade">
          <div v-if="!match.hasStarted && match.players && match.players.length > 0" class="player-info-container mb-3">
            <div class="alert alert-warning" v-if="!hasPlayersOnField">
              {{$t('play.infoSelectPlayers')}}
            </div>        
            <div class="alert alert-primary" v-if="hasPlayersOnField">
              {{$t('play.infoBeforeStart')}}                   
            </div>
          </div>
        </transition>
        <transition-group name="flip-list" tag="div">
          <div v-for="player in match.players" :key="player.id">
            <div
              class="alert mb-2 py-2"
              v-bind:class="{
                'alert-success': player.isOnField,
                'alert-secondary': !player.isOnField
              }"
            >
              <div class="row">
                <div class="col-5">
                  {{ player.name }}
                </div>              
                <div class="col-7 text-right">
                  <span class="text-secondary mr-3" v-if="player.isOnField">{{
                    player._timeOnField
                  }}</span>
                  <span class="text-secondary mr-3" v-if="!player.isOnField">{{
                    player._timeOffField
                  }}</span>
                  <span>{{ player._timeTotal }}</span>
                  <a
                    class="ml-2"
                    v-if="!player.isOnField"
                    v-on:click="putOnField(player)"
                  >
                    <svg
                      width="1.5em"
                      height="1.5em"
                      viewBox="0 0 16 16"
                      class="bi bi-box-arrow-in-right"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0v-2z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"
                      />
                    </svg>
                  </a>
                  <a
                    class="ml-2"
                    v-if="player.isOnField"
                    v-on:click="takeOfField(player)"
                  >
                    <svg
                      width="1.5em"
                      height="1.5em"
                      viewBox="0 0 16 16"
                      class="bi bi-box-arrow-left"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </transition-group>
        <div class="alert alert-light mb-2 pt-2 mb-3 text-center" v-if="match.players && match.players.length > 0">
            <div class="row">
              <div class="col font-italic">
                {{$t('play.explainRowDetails')}}   
              </div>
            </div>
        </div>
      </div>
    </transition>
    <nav class="navbar fixed-bottom navbar-light bg-light border-top pb-1">
      <div class="container">
        <div class="row">
          <div class="col text-left">
            <button
              class="btn btn-success mr-1 px-3 add-goal"
              v-on:click="setHomeCount(match.homeCount + 1)"
            >
              +
            </button>
            <button
              class="btn btn-secondary"
              v-on:click="setHomeCount(match.homeCount - 1)"
            >
              -
            </button>
          </div>
          <div class="col text-center mt-3">
            <h2 class="mb-0">{{ match.homeCount }} - {{ match.awayCount }}</h2>
            <small class="text-muted">{{$t('play.result')}}  </small>
          </div>
          <div class="col text-right">
            <button
              class="btn btn-secondary mr-1"
              v-on:click="setAwayCount(match.awayCount - 1)"
            >
              -
            </button>
            <button
              class="btn btn-success px-3 add-goal"
              v-on:click="setAwayCount(match.awayCount + 1)"
            >
              +
            </button>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";
import moment from "moment";
import { Match, Player } from "../models/Models";
import { set, get, del } from "idb-keyval";
import router from '../router';

export default class MatchPlay extends Vue {
  private match: Match = new Match();
  private hasPlayersOnField = false;
  public matchLoaded = false;
  
  beforeCreate() {
    this.match = new Match();
  }

  async created() {
    const id = (this as any).$route.params.id;
    this.match = await get(id);
    this.match.matchPlayedTime = this.getMatchPlayedTime();
    
    this.sortPlayers();

    this.match.players.forEach(p => {
      p._timeOnField = this.getTimeOnField(p);
      p._timeOffField = this.getTimeOffField(p);
      p._timeTotal = this.getTimeTotal(p);
    });

    this.matchLoaded = true;

    setInterval(() => {
      if (this.match.isRunning) {
        this.match.matchPlayedTime = this.getMatchPlayedTime();

        this.match.players.forEach(p => {
          p._timeOnField = this.getTimeOnField(p);
          p._timeOffField = this.getTimeOffField(p);
          p._timeTotal = this.getTimeTotal(p);
        });
      }
    }, 500);
  }

  editMatch(match: Match) {
    router.push({ name: "MatchDetails", params: { id: match.id } });
  }

  async deleteMatch() {
    if (confirm(this.$t('details.confirmDelete'))) {
      if (!this.match) {
        return;
      }
      await del(this.match.id);

      router.push({ name: "Matches"});
    }
  }

  async restartMatch() {
    if (!confirm(this.$t('play.confirmRestart'))) {
      return;
    }

    this.match.players.forEach(p => {
      p.lastStartOnField = undefined;
      p.lastOfField = undefined;
      p._timeOnField = '00:00';
      p._timeOffField = '00:00';
      p._timeTotal = '00:00';
      p.lastSecondsOnField = 0;
      p.lastSecondsOfField = 0;
      p.totalSecondsOnField = 0;
    });

    this.match.lastStarted = undefined;
    this.match.totalSecondsPlayed = 0;
    this.match.matchPlayedTime = '00:00'; 
    this.match.hasStarted = false;
    this.match.homeCount = 0;
    this.match.awayCount = 0;

    this.sortPlayers();

    await this.saveMatch();
  }

  async startMatch() {
    this.match.players.forEach(p => {
      if (p.isOnField) {
        p.lastStartOnField = moment().format("YYYY-MM-DD HH:mm:ss");
      } else {
        p.lastOfField = moment().format("YYYY-MM-DD HH:mm:ss");
      }
    });

    this.match.isRunning = true;
    this.match.lastStarted = moment().format("YYYY-MM-DD HH:mm:ss");
    this.match.hasStarted = true;

    this.sortPlayers();

    await this.saveMatch();
  }

  async stopMatch() {
    this.match.players.forEach(p => {
      if (p.isOnField) {
        const diff = Math.round(
          moment().diff(moment(p.lastStartOnField)) / 1000
        );
        p.lastSecondsOnField += diff;
        p.totalSecondsOnField += diff;
        p.lastStartOnField = undefined;
      } else {
        const diffOfField = Math.round(
          moment().diff(moment(p.lastOfField)) / 1000
        );
        p.lastSecondsOfField += diffOfField;
        p.lastOfField = undefined;
      }
    });

    const timeSinceLastStarted = Math.round(
      moment().diff(this.match.lastStarted) / 1000
    );
    this.match.totalSecondsPlayed =
      this.match.totalSecondsPlayed + timeSinceLastStarted;

    this.match.isRunning = false;

    this.sortPlayers();

    await this.saveMatch();
  }

  async putOnField(player: Player) {
    if (this.match.isRunning) {
      player.lastStartOnField = moment().format("YYYY-MM-DD HH:mm:ss");
    }

    player.isOnField = true;
    
    this.sortPlayers();

    await this.saveMatch();
  }

  private sortPlayers() {
    if (!this.match) {
      return;
    }

    // game has not started yet, order players by on/off field + alphabeth
    if (!this.match.isRunning && this.match.totalSecondsPlayed == 0) {
      const playersOnField = this.match.players
        .filter(x => x.isOnField)
        .sort((a, b) =>
          a.name.localeCompare(b.name)
        );

      const playersOffField = this.match.players
        .filter(x => !x.isOnField)
        .sort((a, b) =>
          a.name.localeCompare(b.name)
        );

      this.hasPlayersOnField = playersOnField.length > 0;    

      this.match.players = playersOnField.concat(playersOffField);

      return;
    }

    // game has started, order by on/off field + time on field/bench
    const playersOnField = this.match.players
      .filter(x => x.isOnField)
      .sort((a, b) => {
        if (a.lastStartOnField && b.lastStartOnField) {
            const diff = 
              (b.lastSecondsOnField + Math.round(moment().diff(b.lastStartOnField) / 1000)) - 
              (a.lastSecondsOnField + Math.round(moment().diff(a.lastStartOnField) / 1000));
            
            return diff == 0 ? a.name.localeCompare(b.name) : a.lastSecondsOnField - b.lastSecondsOnField > 0 ? -1 : 1
        } else {
          return a.lastSecondsOnField - b.lastSecondsOnField == 0 ? a.name.localeCompare(b.name) : a.lastSecondsOnField - b.lastSecondsOnField > 0 ? -1 : 1
        }
      });

    const playersOffField = this.match.players
      .filter(x => !x.isOnField)
      .sort((a, b) => {
        if (a.lastOfField && b.lastOfField) {
          const diff = 
            (b.lastSecondsOfField + Math.round(moment().diff(b.lastOfField) / 1000)) - 
            (a.lastSecondsOfField + Math.round(moment().diff(a.lastOfField) / 1000));
          return diff == 0 ? a.name.localeCompare(b.name) : diff > 0 ? 1 : -1         
        } else {
          return b.lastSecondsOfField - a.lastSecondsOfField == 0 ? a.name.localeCompare(b.name) : b.lastSecondsOfField - a.lastSecondsOfField > 0 ? 1 : -1 
        }
      });

    this.hasPlayersOnField = playersOnField.length > 0;

    this.match.players = playersOnField.concat(playersOffField);
  }

  getFormattedTime(seconds: number) {
    if (seconds == undefined) {
      return "";
    }

    const minutePart = Math.floor(seconds / 60);
    const secondPart = seconds - 60 * minutePart;

    return (
      minutePart.toString().padStart(2, "0") +
      ":" +
      secondPart.toString().padStart(2, "0")
    );
  }

  async takeOfField(player: Player) {
    const diffSeconds = Math.round(
      moment().diff(player.lastStartOnField) / 1000
    );
    player.totalSecondsOnField += diffSeconds;

    player.lastSecondsOnField = 0;
    player.lastSecondsOfField = 0;
    player.lastStartOnField = undefined;
    if (this.match.isRunning) {
      player.lastOfField = moment().format("YYYY-MM-DD HH:mm:ss");
    }
    player.isOnField = false;
    
    this.sortPlayers();

    await this.saveMatch();
  }

  getMatchPlayedTime() {
    if (!this.match) {
      return "";
    }

    if (!this.match.isRunning) {
      return this.match.matchPlayedTime;
    }

    const timeSinceLastStarted = Math.round(
      moment().diff(this.match.lastStarted) / 1000
    );

    const t = this.getFormattedTime(
      timeSinceLastStarted + this.match.totalSecondsPlayed
    );

    return t;
  }

  getTimeOnField(player: Player) {
    if (!player.isOnField) {
      return "00:00";
    }

    if (
      !this.match.isRunning &&
      player.isOnField &&
      player.lastSecondsOnField
    ) {
      return this.getFormattedTime(player.lastSecondsOnField);
    }

    const v = Math.round(moment().diff(player.lastStartOnField) / 1000);
    const t = this.getFormattedTime(v + player.lastSecondsOnField);
    return t;
  }

  getTimeOffField(player: Player) {
    if (player.isOnField) {
      return "00:00";
    } 

    if (!this.match.isRunning &&
      !player.isOnField &&
      player.lastSecondsOfField
    ) {
      return this.getFormattedTime(player.lastSecondsOfField);
    }

    const v = Math.round(moment().diff(player.lastOfField) / 1000);
    const t = this.getFormattedTime(v + player.lastSecondsOfField);
    return t;
  }

  getTimeTotal(player: Player) {
    const v = Math.round(moment().diff(player.lastStartOnField) / 1000);
    const t = this.getFormattedTime(v + player.totalSecondsOnField);

    return t;
  }

  async setHomeCount(newCount: number) {
    this.match.homeCount = newCount;
    await this.saveMatch();
  }

  async setAwayCount(newCount: number) {
    this.match.awayCount = newCount;
    await this.saveMatch();
  }

  async saveMatch() {
    const match = JSON.parse(JSON.stringify(this.match));
    await set(match.id, match);
  }
}
</script>
